// Turn the subgraph names we already fetched into a protocol term to search the
// substreams registry with.
//
// This exists because the registry cannot be searched by contract address: a
// package's addresses live inside its .spkg, not in any index. Names are the
// only join key the two sides share, so we take the strongest signal we have —
// what curators called the subgraphs indexing this contract — and search on that.

// Chains, versions and boilerplate carry no protocol identity. "v3" and
// "ethereum" describe every second subgraph in the registry.
const NOISE = new Set([
  'subgraph', 'subgraphs', 'protocol', 'network', 'finance', 'exchange', 'token',
  'tokens', 'messari', 'official', 'the', 'and', 'for', 'core', 'main', 'mainnet',
  'testnet', 'sepolia', 'goerli', 'ethereum', 'eth', 'arbitrum', 'optimism', 'base',
  'polygon', 'matic', 'avalanche', 'avax', 'bsc', 'binance', 'gnosis', 'celo',
  'fantom', 'linea', 'scroll', 'zksync', 'blast', 'soneium', 'unichain', 'solana',
  'unnamed', 'test', 'new', 'old', 'data', 'analytics', 'stats', 'fork', 'copy',
]);

const isVersion = (t) => /^v?\d+(\.\d+)*$/.test(t);

export function tokenize(name) {
  return String(name || '')
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter((t) => t.length > 2 && !NOISE.has(t) && !isVersion(t));
}

// Weight by signal so a heavily-curated "Uniswap V3" outranks a long tail of
// forks that happen to touch the same contract.
export function deriveProtocols(subgraphs, limit = 3) {
  const score = new Map();
  for (const sg of subgraphs || []) {
    const weight = 1 + Math.log10(1 + Number(sg.signalledTokens || 0) / 1e18);
    for (const t of new Set(tokenize(sg.name))) {
      score.set(t, (score.get(t) || 0) + weight);
    }
  }
  return [...score.entries()]
    .sort((a, b) => b[1] - a[1])
    .slice(0, limit)
    .map(([term]) => term);
}
